import React from 'react';
import { useSelectTab } from '../../TabLayout/hooks/useSelectTab';
import { useTabContentItem } from '../hooks/useTabContentItem';

type TabContentItemContainerProps = { children: React.ReactNode };

const TabContentItemContainer = ({ children }: TabContentItemContainerProps) => {
	const { blockClass, tabId, componentId } = useTabContentItem();
	const { selectedTab } = useSelectTab();
	if (selectedTab !== tabId) return null;

	return (
		<div
			data-selection={componentId}
			className={` contentItem ${blockClass ? `contentItem--${blockClass} vtex-tab-layout-0-x-contentItem--${blockClass}` : ''} vtex-tab-layout-0-x-contentItem w-100`}
		>
			{children}
		</div>
	);
};

export default TabContentItemContainer;
